<div class="sub-title-copy text-center margin-bottom mb24">
  {{ 'TOO_MANY_ATTEMPTS_PARAGRAPH' | translate }} <strong>{{ 'TIME' | translate }}</strong>
</div>
<div class="row text-center group-login-button">
  <div class="col">
    <mapfre-button
      additionalClasses="link-button small red-link"
      [backIcon]="'assets/img/icons/back-arrow-red.png'"
      [iconClasses]="'align-middle'"
      [routerLink]="['/login']"
      [showIconsCustom]="true">  
      {{ 'LOGIN' | translate }}
    </mapfre-button>
  </div>
</div>